import { ToolbarItem } from "./ToolbarItem";
import { IToolbarItem } from "./IToolbarItem";
import { ToolbarDropdownItem } from "./ToolbarDropdownItem";
import { Toolbar } from "../Toolbar";
import * as ControlFactory from "../../Common/ControlFactory";

export class ToolbarDropdown extends ToolbarItem implements IToolbarItem {

    private items: Array<ToolbarDropdownItem> = [];

    public constructor(control: HTMLElement, toolbar: Toolbar) {
        super(control, toolbar);

        let menu = (control.children.item(1) as HTMLElement);
        for (let i = 0; i < menu.children.length; i++) {
            let menuItem = (menu.children.item(i) as HTMLElement);
            if (menuItem.classList.contains("dropdown-item")) {
                this.items.push(new ToolbarDropdownItem(menuItem, this, toolbar));
            }
        }
    }

    public selectItem(text: string, value: string) {
        (this.control.firstElementChild.firstElementChild as HTMLElement).innerText = text;
        this.control.setAttribute("data-selected-value", value);
    }

    public getSelectedValue(): string {
        return this.control.getAttribute("data-selected-value");
    }

    public selectValue(value: string) {
        for (let item of this.items) {
            if (item.value == value) {
                item.select();
                break;
            }
        }
    }

    public removeAllItems() {
        this.control.lastElementChild.innerHTML = "";
        this.items = [];
    }

    public addItem(text: string, value: string) {
        let a = ControlFactory.createAnchor("dropdown-item", text, [{ name: "data-value", value: value }]);
        this.control.lastElementChild.appendChild(a);
        this.items.push(new ToolbarDropdownItem(a, this, this.toolbar));
    }

    public addDivider() {
        let div = ControlFactory.createDiv("dropdown-divider");
        this.control.lastElementChild.appendChild(div);
    }

    public findItemById(id: string): IToolbarItem {
        if (id == this.id) {
            return this;
        }
        for (let item of this.items) {
            if (item.id == id) {
                return item;
            }
        }
        return null;
    }

    public enable(enable: boolean) {
        if (enable) {
            this.control.classList.remove("disabled");
        }
        else {
            this.control.classList.add("disabled");
        }
    }
}
